<form
  class="update-record-dialog"
  [formGroup]="hotkeyForm"
  (ngSubmit)="createTag()"
>
  <section class="record-summary" aria-label="Tag context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-tag"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">New Tags</span>
      <h2>{{ mainHotkey }}</h2>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <div>
        <h3>Tags</h3>
        <span>{{ tagsArray.length }} added</span>
      </div>

      <button
        pButton
        type="button"
        icon="pi pi-plus"
        label="Add tag"
        class="p-button-sm p-button-outlined"
        (click)="addTag()"
      ></button>
    </div>

    <div class="jobs-list" formArrayName="tags" *ngIf="tagsArray.length; else noTags">
      <article
        class="job-card"
        *ngFor="let tag of tagsArray.controls; index as i"
        [formGroupName]="i"
      >
        <div class="job-card__header">
          <span>Tag {{ i + 1 }}</span>

          <button
            pButton
            type="button"
            icon="pi pi-trash"
            label="Remove"
            class="p-button-sm p-button-text p-button-danger"
            (click)="removeTag(i)"
          ></button>
        </div>

        <div class="form-grid" style="padding: 0.75rem">
          <div class="form-field">
            <label [for]="'hotkeyTag' + i">Tag</label>
            <input
              pInputText
              type="text"
              [id]="'hotkeyTag' + i"
              formControlName="hotkey_tag"
              maxlength="8"
              class="w-full"
            />
            <small
              class="p-error"
              *ngIf="tag.get('hotkey_tag')?.hasError('required') && (tag.get('hotkey_tag')?.touched || tag.get('hotkey_tag')?.dirty)"
            >
              <strong>A tag</strong> is required
            </small>
            <small
              class="p-error"
              *ngIf="tag.get('hotkey_tag')?.hasError('maxlength')"
            >
              Tag must be 8 characters or fewer
            </small>
          </div>

          <div class="form-field">
            <label [for]="'tagDescription' + i">Description</label>
            <input
              pInputText
              type="text"
              [id]="'tagDescription' + i"
              formControlName="tag_description"
              maxlength="100"
              class="w-full"
            />
            <small
              class="p-error"
              *ngIf="tag.get('tag_description')?.hasError('required') && (tag.get('tag_description')?.touched || tag.get('tag_description')?.dirty)"
            >
              <strong>A description</strong> is required
            </small>
            <small
              class="p-error"
              *ngIf="tag.get('tag_description')?.hasError('maxlength')"
            >
              Description must be 100 characters or fewer
            </small>
          </div>
        </div>
      </article>
    </div>

    <ng-template #noTags>
      <div class="jobs-empty">
        <span>No tags added yet</span>
      </div>
    </ng-template>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      icon="pi pi-check"
      label="Create Tags"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
